import { useState } from "react";
import { Keyboard, Delete, CornerDownLeft, X, Languages } from "lucide-react";
import { useApp } from "@/context/AppContext";

const LAYOUTS = {
  ar: ["ض ص ث ق ف غ ع ه خ ح ج", "ش س ي ب ل ا ت ن م ك ط", "ئ ء ؤ ر لا ى ة و ز ظ د"],
  es: ["q w e r t y u i o p", "a s d f g h j k l ñ", "z x c v b n m"],
  num: ["1 2 3 4 5 6 7 8 9 0", "- . , / @ #"],
};
const ORDER = ["ar", "es", "num"];

function Key({ children, onClick, className = "", testid }) {
  return (
    <button type="button" onPointerDown={(e) => e.preventDefault()} onClick={onClick} data-testid={testid}
      className={`h-14 min-w-0 flex-1 rounded-xl bg-white text-[#0B2A5B] text-xl font-bold shadow-sm active:scale-95 active:bg-[#EEF5FB] transition-transform grid place-items-center ${className}`}>{children}</button>
  );
}

export default function KeyboardButton({ value, onChange, onEnter, testid = "osk" }) {
  const { t, lang } = useApp();
  const [open, setOpen] = useState(false);
  const [layout, setLayout] = useState(lang === "ar" ? "ar" : "es");
  const type = (ch) => onChange(value + ch);
  return (
    <>
      <button type="button" onClick={() => setOpen((o) => !o)} aria-label={t("keyboard")} data-testid={`${testid}-toggle`}
        className={`h-14 w-14 shrink-0 rounded-2xl grid place-items-center border transition-colors ${open ? "bg-[#0B2A5B] text-white border-[#0B2A5B]" : "bg-white border-border text-[#0B2A5B]"}`}>
        <Keyboard className="w-6 h-6" />
      </button>
      {open && (
        <div className="fixed inset-x-0 bottom-0 z-[60] bg-[#0D2D3D] p-2 sm:p-3 space-y-2 shadow-2xl rise no-print" data-testid={`${testid}-panel`}>
          <div className="max-w-5xl mx-auto space-y-2">
            {LAYOUTS[layout].map((row) => (
              <div key={row} dir={layout === "ar" ? "rtl" : "ltr"} className="flex gap-1.5">
                {row.split(" ").map((k) => <Key key={k} onClick={() => type(k)} testid={`${testid}-key-${k}`}>{k}</Key>)}
              </div>
            ))}
            <div className="flex gap-1.5" dir="ltr">
              <Key onClick={() => setLayout(ORDER[(ORDER.indexOf(layout) + 1) % ORDER.length])} className="!flex-[1.4] bg-[#0B2A5B] !text-white text-base" testid={`${testid}-layout`}><span className="flex items-center gap-1"><Languages className="w-5 h-5" />{layout.toUpperCase()}</span></Key>
              <Key onClick={() => type(" ")} className="!flex-[5]" testid={`${testid}-space`}>␣</Key>
              <Key onClick={() => onChange(value.slice(0, -1))} className="!flex-[1.4]" testid={`${testid}-backspace`}><Delete className="w-6 h-6" /></Key>
              <Key onClick={() => onChange("")} className="!flex-1 text-sm" testid={`${testid}-clear`}>C</Key>
              <Key onClick={() => { onEnter?.(); setOpen(false); }} className="!flex-[1.4] bg-[#1F9D55] !text-white" testid={`${testid}-enter`}><CornerDownLeft className="w-6 h-6" /></Key>
              <Key onClick={() => setOpen(false)} className="!flex-1 bg-[#F0444B] !text-white" testid={`${testid}-close`}><X className="w-6 h-6" /></Key>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
